import {axios} from "../helpers";

export const getTrackingService = (id) => {

    return axios.get(`${process.env.REACT_APP_API_URL}tracking_api/v1/tracking/${id}`);

}
